"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var PersonalPromoCodesList = /** @class */ (function (_super) {
    __extends(PersonalPromoCodesList, _super);
    function PersonalPromoCodesList(props) {
        return _super.call(this, props) || this;
    }
    PersonalPromoCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    PersonalPromoCodesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PersonalPromoCodesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    PersonalPromoCodesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.DoSetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PersonalPromoCodesList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 180
            }, {
                title: 'Брэнд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Тип обработчика',
                dataIndex: this.props.data.dk_handling_type_title,
                key: this.props.data.dk_handling_type_title,
                width: 120
            }, {
                title: 'Шаблон промокода',
                dataIndex: this.props.data.dk_promocode_template_title,
                key: this.props.data.dk_promocode_template_title,
                width: 120,
                align: "center"
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 140,
                filters: [
                    { text: "Заблокирован", value: 'true' },
                    { text: "Разблокирован", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_locked === (value === 'true'); }
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 220
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }];
    };
    ;
    PersonalPromoCodesList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PersonalPromoCodesList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    PersonalPromoCodesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u043E\u043D\u0443\u0441 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PersonalPromoCodesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PersonalPromoCodesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    PersonalPromoCodesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    PersonalPromoCodesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                    " [",
                                    record.key,
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                    " [",
                                    record.date_added.format(_this.props.state.getDateTimeFormat()),
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                    " [",
                                    record.date_changed.format(_this.props.state.getDateTimeFormat()),
                                    "]")))));
                }, scroll: { x: true } })));
    };
    return PersonalPromoCodesList;
}(React.Component));
exports.default = PersonalPromoCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ui/component/PersonalPromoCodesList.tsx
// module id = 2583
// module chunks = 0